import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { ARService } from '../../ar.service';
import {FeeScheduleDataModel} from '../../../../models/fee-schedule/fee-schedule-data.model';
import {InsuranceExplosionDataModel} from '../../../../models/insurance/insurance-explosion-data.model';
import {CaseProcedureConfigurationModel} from '../../../../models/caseProcedures/case-procedure-configuration.model';
import {CaseProcedureConfigurationARModel} from '../../../../models/accountsReceivable/case-procedure-configuration-ar.model';
import {CreateTransactionItemModel} from '../../../../models/accountsReceivable/create-transaction-item.model';
import {dataARTransaction} from '../../_models/ar.models';
import {FeeScheduleItemDataModel} from '../../../../models/fee-schedule/fee-schedule-item-data.model';
import {FeeScheduleListViewDataModel} from '../../../fee-schedule/models/fee-schedule-list-view.model';
import {DataFeeScheduleItemFee4FeesJoinedModel} from '../../../fee-schedule/models/data-fee-scheduleItem-fee4fees-joined.model';
import {Globals} from '../../../../globals';
import {TdoTableSelectionEvent} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {TdoTableRowModel} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-row.model';
import {Observable} from 'rxjs';
import {DataPatientCaseWorkItemToothModel} from '../../../../models/teeth/data-patient-case-work-item-tooth.model';
import {CaseFormsService} from '../../../case-forms/case-forms.service';
import {CfgARFeeDiscountModel} from '../../../../models/accountsReceivable/cfg-ar-fee-discount.model';
import {DataARTransactionItemModel} from '../../../../models/accountsReceivable/data-ar-transaction-item.model';
import {EnumFeeDiscountCalcTypeEnum} from '../../../../models/enum/enum-fee-discount-calc-type.enum';

@Component({
    selector: 'app-ar-create-transaction',
    templateUrl: './ar-create-transaction.component.html',
    styleUrls: ['./ar-create-transaction.component.css']
})
export class ArCreateTransactionComponent implements OnInit {

    // component mode
    isCreate: boolean = false;
    isCodeEdit: boolean = false;
    isCodeEditSingle: boolean = false;

    isLoading: boolean = false;
    bkCaseProcedures: CaseProcedureConfigurationARModel[] = [];
    cfgCaseProcedures: CaseProcedureConfigurationARModel[] = [];

    bkfeeScheduleItems: DataFeeScheduleItemFee4FeesJoinedModel[] = [];
    feeScheduleItems: DataFeeScheduleItemFee4FeesJoinedModel[] = [];

    keyword: string;
    useExplosionCodes: boolean = false;
    explosionCodes: InsuranceExplosionDataModel[] = [];
    bkExplosionCodes: InsuranceExplosionDataModel[] = [];
    caseWorkItemTeeth: DataPatientCaseWorkItemToothModel[] = [];

    isSearching: boolean = false;
    searchTimeout: any;

    procedureToAdd: DataFeeScheduleItemFee4FeesJoinedModel[] = [];
    explosionsToAdd: InsuranceExplosionDataModel[] = [];
    procedureIds: string[] = [];
    explosionIds: string[] = [];
    existingProcedureCode: string;
    existingProcedure: CaseProcedureConfigurationARModel;
    existingToothID: string;
    transactionDate: any;
    insuranceID: string;
    caseWorkItemID: string;
    organizationID: string;
    feeScheduleID: string;
    docFeeScheduleID: string;
    multipleTeeth: boolean;
    transactionItemID: string = null;
    emptyGuid = '00000000-0000-0000-0000-000000000000';
    searchCode: string = '';
    feeDiscounts: CfgARFeeDiscountModel[] = [];
    LOCID = parseInt(localStorage.getItem('LOCID'));
    ProviderDoctorID: string;
    isDefaultInsurance: boolean = false;

    selectedFeeAdjustment: CfgARFeeDiscountModel;
    selectedFeeDiscounts: CfgARFeeDiscountModel[] = [];

    enumCoverageTypePercent: string = EnumFeeDiscountCalcTypeEnum.Percent;
    enumCoverageTypeAmount: string = EnumFeeDiscountCalcTypeEnum.Money;

    searchPredicate: (data: any, filter: string) => boolean;
    searchPredicateExplosion: (data: any, filter: string) => boolean;

    constructor(
        public dialogRef: MatDialogRef<ArCreateTransactionComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private arService: ARService,
        private caseService: CaseFormsService,
        private snackBar: MatSnackBar,
        public globals: Globals,
    ) {
        this.searchPredicate = (d: TdoTableRowModel, filter: string) => {
            const pName = d.model.Description ? d.model.Description : '';
            const pCode = d.model.Code ? d.model.Code : '';
            if (pName.toLowerCase().includes(filter) || pCode.toLowerCase().includes(filter)) {
                return true;
            }
        };
        this.searchPredicateExplosion = (d: TdoTableRowModel, filter: string) => {
            const pName = d.model.Description ? d.model.Description : '';
            if (pName.toLowerCase().includes(filter)) {
                return true;
            }
        };
    }

    ngOnInit() {

        // get case work item from global
        if (this.data.caseWorkItemID) {
            this.caseWorkItemID = this.data.caseWorkItemID;
        }
        else {
            this.caseWorkItemID = this.globals.currentPatientCaseWorkItemID;
        }

        // params
        if (this.data.searchCode) { this.searchCode = this.data.searchCode; }
        if (this.data.transactionItemID) { this.transactionItemID = this.data.transactionItemID; }
        if (this.data.feeScheduleID) { this.feeScheduleID = this.data.feeScheduleID; }
        if (this.data.procedureCode) {this.existingProcedureCode = this.data.procedureCode; }
        if (this.data.ToothID) {this.existingToothID = this.data.ToothID; }
        if (this.data.OrganizationID) {this.organizationID = this.data.OrganizationID; }
        if (this.data.InsuranceID) { this.insuranceID = this.data.InsuranceID; }
        if (this.data.DocFeeScheduleID) { this.docFeeScheduleID = this.data.DocFeeScheduleID; }
        if (this.data.DoctorId) { this.ProviderDoctorID = this.data.DoctorId; }
        if (this.data.isDefaultInsurance) { this.isDefaultInsurance = this.data.isDefaultInsurance; }

        // component mode
        if (this.data.isCreate) { this.isCreate = this.data.isCreate; }
        if (this.data.isCodeEdit) { this.isCodeEdit = this.data.isCodeEdit; }
        if (this.data.isCodeEditSingle) { this.isCodeEditSingle = this.data.isCodeEditSingle; }

        // load view
        this.init();
    }

    async init() {

        const promises: any[] = [
            // this.getCfgCaseProcedures()
            this.getFeeScheduleChildItems(),
            this.getCaseWorkItemTeeth(this.caseWorkItemID),
            this.getDiscounts(),
        ];
        if (!this.isCodeEditSingle) {
            promises.push(this.getExplosionCodesForInsurance(this.organizationID));
        }

        this.isLoading = true;

        try {

            const results: any[] = await Promise.all(promises);
            this.feeScheduleItems = results[0];
            this.bkfeeScheduleItems = results[0];
            this.caseWorkItemTeeth = results[1];
            this.feeDiscounts = results[2];

            if(this.caseWorkItemTeeth.length > 1) {
              this.caseWorkItemTeeth.forEach(tooth => {
                tooth.isSelected = false;
              });

            }
            else {
              this.caseWorkItemTeeth.forEach(tooth => {
                tooth.isSelected = true;
              });

            }

            // if editing a code, pre-select it now
            if (this.isCodeEdit || this.isCodeEditSingle) {
                this.cfgCaseProcedures.forEach(a => {
                    if (a.Code === this.existingProcedureCode) {
                        a.DATA_SELECTED = true;
                    }
                });
            }

            if (this.isCodeEditSingle) {
                this.existingProcedure = this.cfgCaseProcedures.find(a => a.Code === this.existingProcedureCode);
            }

            this.bkCaseProcedures = this.cfgCaseProcedures;

            if (results.length > 1) {
                this.explosionCodes = results[1];
                this.bkExplosionCodes = results[1];
            }

        } catch (err) {
            this.createMessage('Something went wrong', 'Error');
        }

        this.isLoading = false;
    }

    getExplosionCodesForInsurance(OrganizationId: string) {
        return this.arService.getExplosionCodesForInsurance(OrganizationId).toPromise();
    }

    getCfgCaseProcedures() {
        return this.arService.getCfgCaseProcedures(this.globals.LOCID).toPromise();
    }

    getCaseWorkItemTeeth(caseWorkItemId: string) {
        return this.caseService.getCaseWorkItemTeeth(caseWorkItemId).toPromise();
    }

    getFeeScheduleChildItems() {
        if (this.docFeeScheduleID) {
            return this.arService.getFeeScheduleChildItems(this.docFeeScheduleID).toPromise();
        }
    }

    onTypeChange(_) {
        this.cfgCaseProcedures = this.bkCaseProcedures;
        this.explosionCodes = this.bkExplosionCodes;
    }

    onSearchEvent(searchTerm: string) {
        if (this.useExplosionCodes) {
            this.searchExplosions(searchTerm);
        } else {
            this.searchProcedures(searchTerm);
        }
    }

    searchExplosions(searchTerm: string) {
        this.isSearching = true;

        searchTerm = searchTerm.toLowerCase();
        searchTerm = searchTerm.trim();

        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = false;
        }

        this.explosionCodes = this.bkExplosionCodes;

        if (!searchTerm) {
            this.isSearching = false;
            return;
        }

        this.searchTimeout = setTimeout(_ => {
            this.explosionCodes = this.bkExplosionCodes.filter(explosionCode => {
                let flag = false;
                let searchField: string;

                searchField = explosionCode.Name.trim().toLowerCase();

                if (searchField.indexOf(searchTerm) > -1) {
                    flag = true;
                }
                searchField = '';
                explosionCode.dataInsuranceExplosionCodes.forEach(code => {
                    searchField += (code.Code + ' ');
                });
                searchField = searchField.trim().toLowerCase();
                if (searchField.indexOf(searchTerm) > -1) {
                    flag = true;
                }

                return flag;
            });
            this.isSearching = false;
        }, 500);
    }

    searchProcedures(searchTerm: string) {

        this.isSearching = true;

        searchTerm = searchTerm.toLowerCase();
        searchTerm = searchTerm.trim();

        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = false;
        }

        this.feeScheduleItems = this.bkfeeScheduleItems;

        if (!searchTerm) {
            this.isSearching = false;
            return;
        }

        this.searchTimeout = setTimeout(_ => {
            this.feeScheduleItems = this.bkfeeScheduleItems.filter(a => {
                let flag = false;
                let searchProcedure: string;
                let searchCode: string;

                searchProcedure = a.Description ? a.Description.trim().toLowerCase() : '';
                searchCode = a.Code ? a.Code.trim().toLowerCase() : '';

                if (searchProcedure.indexOf(searchTerm) > -1 || searchCode.indexOf(searchTerm) > -1) {
                    flag = true;
                }

                return flag;
            });
            this.isSearching = false;
        }, 1000);
    }

    close(payload) {
        this.dialogRef.close(payload);
    }

    createMessage(message, type) {
        this.snackBar.open(message, type, {
            duration: 3000,
            verticalPosition: 'top'
        });
    }

    async submitTransactions() {

        if (!this.isCodeEditSingle) {

            let isFound = false;
            this.caseWorkItemTeeth.forEach(a=> {
              if(a.isSelected == true)
              {
                isFound =true;
              }
            });
            if(!isFound)
            {
              this.createMessage('Please select a tooth and try again !', 'Stop');
              return;
            }


            const procedurePayloads: CreateTransactionItemModel[] = [];

            console.log('to add', this.procedureToAdd);

            // for now, only using the last selected procedure, in the future will want x procedures
            this.caseWorkItemTeeth.forEach(b => {
                if (b.isSelected === true) {
                    const procedurePayload = this.createPayloadFromProcedure(this.procedureToAdd[this.procedureToAdd.length - 1], b);
                    if (procedurePayload) {
                        procedurePayloads.push(procedurePayload);
                    }
                }
            });

            const explosionPayloads: CreateTransactionItemModel[] = this.createExplosionCodesPayload();

            try {
                this.isLoading = true;
                const transaction: dataARTransaction = await this.createTransactionItems([...procedurePayloads, ...explosionPayloads], this.transactionItemID);
                this.createMessage('Transaction items added', 'Success');
                this.close(transaction);
            } catch (err) {
                this.createMessage('Something went wrong', 'Error');
                this.close(false);
            }
        }
        else {
            this.close(this.procedureToAdd);
        }

        this.isLoading = false;
    }

    addTransactionExplosionToAddList(explosion) {
        this.explosionsToAdd.push(explosion);
        this.explosionIds.push(explosion.ExplosionID);
    }

    createTransactionFromExplosion(explosion) {
        const promise = new Promise(async (resolve, reject) => {

            const promises = explosion.dataInsuranceExplosionCodes.map(code => this.createSingleTransactionFromExplosionCode(code));

            try {
                const results: any[] = await Promise.all(promises);
                resolve(results);
            } catch (err) {
                reject(err);
            }

        });
        return promise;
    }

    createSingleTransactionFromExplosionCode(code) {
        const promise = new Promise((resolve, reject) => {

            const procedures: CaseProcedureConfigurationARModel[] = this.cfgCaseProcedures.filter(caseProcedure => caseProcedure.Code.trim().toLowerCase() === code.Code.trim().toLowerCase());

            if (procedures.length === 0) {
                resolve(null);
                return;
            }

            if (procedures.length > 1) {
                // do something to ask to clarify
                resolve(null);
                return;
            }

            const procedure = procedures[0];

            const payload: CreateTransactionItemModel = new CreateTransactionItemModel();
            payload.PatientId = this.data.PatientId;
            payload.PatientCaseId = this.data.PatientCaseId;
            payload.CaseProcedureId = procedure.CaseProcedureId;
            payload.Code = code.Code;
            payload.LOCID = parseInt(localStorage.getItem('LOCID'));

            this.isLoading = true;
            this.arService.createTransactionItem(payload)
                .subscribe(resolve, reject);
        });
        return promise;
    }

    createPayloadFromProcedure(procedure, tooth: DataPatientCaseWorkItemToothModel) {
        const payload: CreateTransactionItemModel = new CreateTransactionItemModel();
        payload.PatientId = this.data.PatientId;
        payload.PatientCaseId = this.data.PatientCaseId;
        payload.CaseProcedureId = procedure.CaseProcedureId;
        payload.Code = procedure.Code;
        payload.CodeDescription = procedure.Description;
        payload.LOCID = parseInt(localStorage.getItem('LOCID'));
        payload.ToothID =  tooth.ToothID;
        payload.CaseWorkItemID = this.caseWorkItemID;
        payload.CaseWorkItemToothId = tooth.CaseWorkItemToothId;
        payload.InsuranceID = this.insuranceID; // need to set this onInit
        payload.ProviderDoctorID = this.data.DoctorId;
        payload.FeeScheduleID = this.feeScheduleID;
        payload.FeeScheduleItemID = procedure.FeeScheduleItemID;
        payload.DocFeeScheduleID = procedure.DocFeeScheduleID;
        payload.PatientInsuranceID = this.data.PatientInsuranceID;
        payload.TransactionDate = new Date();
        payload.enumFeeItemCategoryId = procedure.enumFeeItemCategoryId;
        payload.WorkItemEventId = this.globals.currentPatientCaseWorkItemEventID;
        payload.ItemOrder = procedure.ItemOrder;

        if (this.selectedFeeAdjustment) {
            payload.DiscountID = this.selectedFeeAdjustment.DiscountID;
            payload.DiscountAmount = this.selectedFeeAdjustment.DiscountAmount;
            payload.DiscountPCT = this.selectedFeeAdjustment.DiscountPCT;
            payload.enumFeeDiscountCalcTypeId = this.selectedFeeAdjustment.enumFeeDiscountCalcTypeId;
        }

        return payload;
    }

    createExplosionCodesPayload() {
        const procedurePayloads: CreateTransactionItemModel[] = [];
        this.explosionsToAdd.forEach(a => { // explosion loop

            let codeStringList: string = '';
            a.dataInsuranceExplosionCodes.forEach(ex => {
                codeStringList += ex.Code.trim().toLowerCase() + '_';
            });
            const procedures: DataFeeScheduleItemFee4FeesJoinedModel[] = this.feeScheduleItems.filter(caseProcedure => codeStringList.indexOf(caseProcedure.Code.trim().toLowerCase()) !== -1);

            procedures.forEach(b => { // procedure loop
                this.caseWorkItemTeeth.forEach(c => { // teeth loop
                    if (c.isSelected === true) {
                        const procedurePayload = this.createPayloadFromProcedure(b, c);
                        if (procedurePayload) {
                            procedurePayloads.push(procedurePayload);
                        }
                    }
                });
            });
        });

        return procedurePayloads;
    }

    createTransactionItems(payloads, transactionItemID: string = null) {
        if (!transactionItemID) { transactionItemID = this.emptyGuid; }
        return this.arService.createTransactionItems(payloads, transactionItemID).toPromise();
    }

    createTransaction(procedure) {

        const payload: CreateTransactionItemModel = new CreateTransactionItemModel();
        payload.PatientId = this.data.PatientId;
        payload.PatientCaseId = this.data.PatientCaseId;
        payload.CaseProcedureId = procedure.CaseProcedureId;
        payload.Code = procedure.Code;
        payload.LOCID = parseInt(localStorage.getItem('LOCID'));

        return this.arService.createTransactionItem(payload).toPromise();
    }

    // Handle selection and deselection of rows model data
    onRowSelected(event: TdoTableSelectionEvent) {
        const procedure: DataFeeScheduleItemFee4FeesJoinedModel = event.model;

        if (procedure) {
            if (event.isSelected) {
                procedure.ItemOrder = this.procedureToAdd.length + 1;
                this.procedureToAdd.push(procedure);
                this.procedureIds.push(procedure.FeeScheduleItemID);
            }
            else {
                const indexOfProcedure = this.procedureToAdd.findIndex(proc => proc.FeeScheduleItemID === procedure.FeeScheduleItemID);

                const indexOfProcedureId = this.procedureIds.indexOf(procedure.FeeScheduleItemID);
                this.procedureToAdd.splice(indexOfProcedure, 1);
                this.procedureIds.splice(indexOfProcedureId, 1);
            }
        }
    }

    // Handle selection and deselection of rows model data
    onRowSelectedExploded(event: TdoTableSelectionEvent) {
        const explosion: InsuranceExplosionDataModel = event.model;

        if (explosion) {
            if (event.isSelected) {
                this.explosionsToAdd.push(explosion);
                this.explosionIds.push(explosion.ExplosionID);
            }
            else {
                const indexOfProcedure = this.explosionsToAdd.findIndex(proc => proc.ExplosionID === explosion.ExplosionID);

                const indexOfProcedureId = this.explosionIds.indexOf(explosion.ExplosionID);
                this.explosionsToAdd.splice(indexOfProcedure, 1);
                this.explosionIds.splice(indexOfProcedureId, 1);
            }
        }
    }

    isDiscountAvailable(ProviderDoctorId: string, level: number) {
        const feeDiscount = this.feeDiscounts.find(a =>
            a.DiscountName === 'Level' + level
      && a.ProviderDoctorId === ProviderDoctorId
      && a.LOCID === this.LOCID);
        if (feeDiscount && ProviderDoctorId) {
            if (
                (feeDiscount.enumFeeDiscountCalcTypeId === this.enumCoverageTypePercent && feeDiscount.DiscountPCT === 0)
        ||
        (feeDiscount.enumFeeDiscountCalcTypeId === this.enumCoverageTypeAmount && feeDiscount.DiscountAmount === 0)
            ) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    }

    getDiscountAmountForTooltip(feeDiscount: CfgARFeeDiscountModel) {
        if (feeDiscount) {
            if (feeDiscount.enumFeeDiscountCalcTypeId === EnumFeeDiscountCalcTypeEnum.Percent) {
                return feeDiscount.DiscountPCT + '%';
            }
            else if (feeDiscount.enumFeeDiscountCalcTypeId === EnumFeeDiscountCalcTypeEnum.Money) {
                return '$' + feeDiscount.DiscountAmount;
            }
            else {
                return 'No Discount';
            }
        }
        else {
            return 'No Discount';
        }
    }

    getDiscounts() {

        // filter discounts for doctor/locid
        // this.selectedFeeDiscounts = this.feeDiscounts.filter(a => a.ProviderDoctorId === this.ProviderDoctorID && a.LOCID === this.LOCID);

        return this.arService.getDiscountsForDoctorLocation(this.ProviderDoctorID, this.LOCID).toPromise();
    }

    setSelectedFeeAdjustment(adj: CfgARFeeDiscountModel) {
        this.selectedFeeAdjustment = adj;
    }
}
